import React from 'react'
import { Flex } from 'antd-mobile'
import classNames from 'classnames'
import s from './form-row.module.scss'

const FieldTitle = (props) =>
  <div className={s.fieldTitle}><span style={{
    visibility: props.required ? 'visible' : 'hidden'
  }}>*</span>{props.children}</div>

export default props => 
  <div className={s.field} onClick={props.onClick}>
    <div className={classNames(s.borderOuter, {
      [s.sep]: props.showBorder,
    })}>
      <div className={classNames(s.inner)}>
        <Flex className={s.main}>
          <FieldTitle required={props.required}>{props.title}</FieldTitle>
          <input
            {...props.inputProps}
          />
        </Flex>
      </div>
      {props.children}
    </div>
  </div>